import { useEffect } from "react";

// Lightweight SEO: sets title, meta description, canonical + JSON-LD per page.
export default function Seo({ title, description, path = "/", jsonLd, locale }) {
  useEffect(() => {
    document.title = title;

    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    const origin = window.location.origin;
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    if (locale) setMeta("property", "og:locale", locale);
    setMeta("property", "og:image", origin + "/og-image.jpg");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", origin + "/og-image.jpg");

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", origin + path);

    // hreflang alternates (client-side i18n via ?lang= param)
    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((n) => n.remove());
    const alternates = [
      ["en", origin + path],
      ["it", origin + path + "?lang=it"],
      ["x-default", origin + path],
    ];
    alternates.forEach(([hl, href]) => {
      const link = document.createElement("link");
      link.setAttribute("rel", "alternate");
      link.setAttribute("hreflang", hl);
      link.setAttribute("href", href);
      document.head.appendChild(link);
    });

    let ld = document.getElementById("page-jsonld");
    if (ld) ld.remove();
    if (jsonLd) {
      ld = document.createElement("script");
      ld.type = "application/ld+json";
      ld.id = "page-jsonld";
      ld.text = JSON.stringify(jsonLd);
      document.head.appendChild(ld);
    }
  }, [title, description, path, jsonLd, locale]);

  return null;
}
